import { Route, Routes } from 'react-router-dom';
import AdminMerchantsPage from '../pages/admin-pages/admin-merchants.page';
import SettlementsPage from '../pages/admin-pages/settlements-page';
import ResellerTransactionPage from '../pages/merchant-pages/reseller-transactions.page';
import { GlobalRoutes } from './global.routes';

function ResellerRoutes() {
  return (
    <Routes>
      {GlobalRoutes()}
      <Route path="merchants" element={<AdminMerchantsPage />} />
      <Route path="transactions" element={<ResellerTransactionPage />} />
      <Route path="settlements" element={<SettlementsPage />} />
    </Routes>
  );
}

export default ResellerRoutes;
